import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import Link from 'next/link';
import { Button } from 'stylus-ui/Button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'stylus-ui/DropdownMenu';

export const SupportDropdown = () => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button variant='ghost' size='large' icon={faQuestionCircle} />
    </DropdownMenuTrigger>
    <DropdownMenuContent align='end'>
      <Link target='_blank' href='https://support.scribehow.com/hc/en-us'>
        <DropdownMenuItem>Help Center</DropdownMenuItem>
      </Link>
      <Link target='_blank' href='https://support.scribehow.com/hc/en-us/requests/new'>
        <DropdownMenuItem>Contact Support</DropdownMenuItem>
      </Link>
      <Link target='_blank' href='https://scribehow.com/gallery'>
        <DropdownMenuItem>Gallery</DropdownMenuItem>
      </Link>
      <Link target='_blank' href='https://scribe.launchnotes.io/?utm_source=embed&utm_content=widget-list'>
        <DropdownMenuItem>What&apos;s New</DropdownMenuItem>
      </Link>
      <Link target='_blank' href='https://get.scribehow.com/sales/'>
        <DropdownMenuItem>Contact Sales</DropdownMenuItem>
      </Link>
    </DropdownMenuContent>
  </DropdownMenu>
);
